export default class DtoUserStation {
    constructor(obj) {
        this.login = obj.login
        this.stationType = obj.stationType
        this.stationCode = obj.stationCode
        this.selectedMode = obj.selectedMode
    }
}